import { Component, Injector } from '@angular/core';


import { ActivatedRoute } from '@angular/router';
import { ViewComponent } from '../../abstract/view.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/validator/email-validator';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/services/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from 'src/app/component/message-dialog.component';

@Component({
  selector: 'contact',
  styleUrls: ['./contact.component.scss'],
  templateUrl: './contact.component.html',
})
export class ContactComponent extends ViewComponent {

  override form = new FormGroup({
    email: new FormControl<string>('', [Validators.required, emailValidator(this.translate)]),
    subject: new FormControl<string>(''),
    message: new FormControl<string>(''),
  });

  constructor(
    protected override injector: Injector,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private translate: TranslateService,
    private adminService: AdminService,
    public dialog: MatDialog,
  ) {
    super(injector);
  }
  submited: boolean = false;

  submitting: boolean = false;


  ngOnInit(): void {

  }

  onSubmit(): void {
    if (this.form.valid) {
      this.submitting = true;
      this.disableAllFormControl()
      const formData = this.form.value;
      this.adminService.sendContact(formData).subscribe({
        next: (result) => {
          this.submited = true;
        },
        error: (error) => {
          this.handlError(error);
          const dialogRef = this.dialog.open(MessageDialogComponent, {
            data: {
              message: error.error.message,
              okColor: null,
              okTitle: this.translate.instant('BUTTON.CLOSE'),
              onOk: () => { this.enableAllFormControl(); this.submitting = false; },
            }
          });
        }
      });
    }
  }
}
